import axios from '@axios'

// eslint-disable-next-line import/prefer-default-export
export default class BankAccountService {
  deleteBank = id => new Promise((resolve, reject) => {
    axios.delete(`specialists/bank_account/${id}`)
      .then(resp => {
        resolve(resp)
      })
      .catch(err => {
        reject(err)
      })
  })

  createBank = (id, data) => new Promise((resolve, reject) => {
    axios.post(`specialists/bank_account/${id}`, data)
      .then(resp => {
        resolve(resp)
      })
      .catch(err => {
        reject(err)
      })
  })
}
